import { COUNTRIES, CURRENT_COUNTRY_ID } from '~constants/environment';

export const FIELDS = {
  name: 'name',
  email: 'email',
  phone: 'phone',
  cardCode: 'cardCode',
  privacyPolicies: 'privacyPolicies',
  tip: 'tipField',
  freeGarlicSauces: 'freeGarlicSauces',
  idNumber: 'idNumber',
  identificationType: 'identificationType',
  clientDocumentId: 'clientDocumentId',
  nifEnabled: 'nifEnabled',
  nif: 'nif'
};

export const timeToExpireCookie = '1000';

export const GUEST_PREFIX = 'guest-';

export const IS_CA = [COUNTRIES.pa, COUNTRIES.cr, COUNTRIES.gt].includes(CURRENT_COUNTRY_ID);
